export const APP_GUIDE_DISMISSED_KEY = "app-guide-dismissed";
const LEGACY_SEEN_KEY = "app-guide-seen";

/**
 * Session flag for the Journey Guide modal. Missing key means first visit
 * (may auto-open). Any storage failure is treated as dismissed so the guide
 * stays off rather than popping up at the wrong time.
 */
export const readAppGuideDismissed = (): boolean => {
  try {
    if (sessionStorage.getItem(APP_GUIDE_DISMISSED_KEY) === "true") {
      return true;
    }
    if (localStorage.getItem(LEGACY_SEEN_KEY) === "true") {
      sessionStorage.setItem(APP_GUIDE_DISMISSED_KEY, "true");
      return true;
    }
    return false;
  } catch {
    return true;
  }
};

export const writeAppGuideDismissed = (): void => {
  try {
    sessionStorage.setItem(APP_GUIDE_DISMISSED_KEY, "true");
  } catch {
    // ignore storage errors (private mode, etc.)
  }
};
